import { DOCUMENT } from "@angular/common";
import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { Rating } from "@edp-models/rating.model";
import { SaveRatingStatus, SubmitRating } from "@edp-store/actions/rating.actions";
import { getRatingStatus } from "@edp-store/selectors/rating.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { select, Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { DeviceDetectorService } from "ngx-device-detector";
import { Subject } from "rxjs";
import { EdpRatingOption } from "./edp-rating.model";

@Component({
    selector: "edp-rating",
    templateUrl: "./edp-rating.component.html",
    styleUrls: ["./edp-rating.component.scss"],
})
export class EdpRatingComponent implements OnInit, OnDestroy {
    ratingStatus$ = this.store.pipe(select(getRatingStatus));
    score: EdpRatingOption;
    message: string = null;
    placeholder: string;
    storeLink: string;
    openedKeyboard = false;
    rating: EdpRatingOption[] = [
        {
            value: 1,
            active: false,
        },
        {
            value: 2,
            active: false,
        },
        {
            value: 3,
            active: false,
        },
        {
            value: 4,
            active: false,
        },
        {
            value: 5,
            active: false,
        },
    ];
    private unsubscribe = new Subject();

    constructor(
        private store: Store<IAppState>,
        private translate: TranslateService,
        @Inject(DOCUMENT) private document: Document,
        private deviceDetector: DeviceDetectorService
    ) {
        this.storeLink =
            this.deviceDetector.isMobile() && this.deviceDetector.device === "Android"
                ? this.translate.instant("pt.edp.edponline.rating.googleStoreLink")
                : this.translate.instant("pt.edp.edponline.rating.appleStoreLink");
    }

    ngOnInit(): void {
        this.document.body.classList.add("overflow-hidden");
    }

    public ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    rate(score: EdpRatingOption) {
        this.score = score;
        this.message = this.score.value > 3 ? this.message : null;
        this.rating = this.rating.map(item => ({ ...item, active: item.value <= score.value }));

        this.placeholder =
            this.score.value <= 2
                ? this.translate.instant("pt.edp.edponline.rating.placeholder.rated1")
                : this.translate.instant("pt.edp.edponline.rating.placeholder.rated3");
    }

    submitRate() {
        this.document.body.classList.remove("overflow-hidden");
        this.store.dispatch(
            new SubmitRating({
                rate: this.score.value,
                state: "Avaliado_low",
                comment: this.message || null,
                showMessage: true,
                showRating: true,
            })
        );
    }

    close() {
        this.document.body.classList.remove("overflow-hidden");
        const state = this.score && this.score.value && this.score.value > 3 ? "Avaliado_high" : "Fechado";
        let args: Rating = { state, showMessage: false, showRating: false };
        if (this.score && this.score.value) {
            args = { ...args, rate: this.score.value };
        }
        this.store.dispatch(new SubmitRating(args));
    }

    rateStore() {
        this.document.body.classList.remove("overflow-hidden");
        this.store.dispatch(new SubmitRating({ rate: this.score.value, state: "Avaliado_store", showMessage: false, showRating: false }));
    }

    skip(state: string) {
        this.document.body.classList.remove("overflow-hidden");
        this.store.dispatch(new SubmitRating({ state, showMessage: false, showRating: false }));
    }

    closeMessage() {
        this.document.body.classList.remove("overflow-hidden");
        this.store.dispatch(new SaveRatingStatus({ showRating: false }));
    }

}
